<div class="body"
     [class.narrow]="narrow">
  <ng-content></ng-content>
</div>
